export default "__VITE_ASSET__bxpPItT5__"